import { Component, computed, inject, Signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@next/core-lib/i18n';

import { FmsSyncStore } from '@app/shared/fms-sync/fms-sync.store';
import { CropYearService } from '@app/shared/services/crop-year.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-sync-from-fms-button',
  templateUrl: './sync-from-fms-button.component.html',
  styleUrls: ['./sync-from-fms-button.component.scss'],
  imports: [MatButton, MatProgressSpinner, MatTooltip, TranslatePipe, NgOptimizedImage],
})
export class SyncFromFmsButtonComponent {
  private readonly store = inject(FmsSyncStore);
  private readonly cropYearService = inject(CropYearService);

  protected readonly showButton: Signal<boolean> = computed(
    () => this.store.isEnabled() && !this.cropYearService.isReadOnly(),
  );
  protected readonly isSyncing: Signal<boolean> = computed(() => this.store.isSynchronizing());

  protected onSyncFms(): void {
    if (this.cropYearService.isReadOnly()) return;
    void this.store.triggerSync();
  }
}
